import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "src/utils/api";

export const useFormTemplateStore = defineStore("form_template_store", {
  persist: true,
  state: () => ({
    templateList: [],
    totalForms: 0,
    dynamicReportForms: []
  }),
  getters: {
    getDynamicReportFormsList: (state) => state.dynamicReportForms
  },
  actions: {
    async getTemplatesList(config) {
      let _res = await Api.FormTemplates.getFormTemplatesList(config);
      this.totalForms = _res.totalItems || 0;
      this.templateList = _res.data || [];
      return _res;
    },

    async getFormTemplateById(id, fetchNew = false) {
      if (!fetchNew) {
        // Check if the template already exists in the local state
        const existingTemplate = this.templateList.find(
          (template) => template.id === id
        );
        if (existingTemplate) {
          return { data: existingTemplate };
        }
      }

      const _res = await Api.FormTemplates.getFormTemplateById(id);
      if (_res.data) {
        this.templateList.push(_res.data);
      }
      return _res;
    },

    async updateFormTemplate(data) {
      const _res = await Api.FormTemplates.updateFormTemplate(data);
      if (_res.data) {
        // Update the template in the local state
        const updatedData = Array.isArray(_res.data) ? _res.data[0] : _res.data;
        const index = this.templateList.findIndex(
          (template) => template.id === data.id
        );
        if (index !== -1) {
          this.templateList[index] = {
            ...this.templateList[index],
            ...updatedData
          };
        }
      }
      return _res;
    },
    async getDynamicReportForms() {
      const _res = await Api.FormTemplates.getDynamicReportForms();
      this.dynamicReportForms = _res.data || [];
      return _res;
    }
  },
  $reset() {
    this.templateList = [];
    this.totalForms = 0;
    this.dynamicReportForms = [];
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useFormTemplateStore, import.meta.hot)
  );
}
